// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/webhook/api/webhook.proto (package gx.webhook.api, syntax proto3)
/* eslint-disable */

import { WebhookSourceService } from "./webhook_pb.js";

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.CreateWebhookSource
 */
export const createWebhookSource = WebhookSourceService.method.createWebhookSource;

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.GetWebhookSource
 */
export const getWebhookSource = WebhookSourceService.method.getWebhookSource;

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.GetWebhookSourceBySourceId
 */
export const getWebhookSourceBySourceId = WebhookSourceService.method.getWebhookSourceBySourceId;

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.ListWebhookSources
 */
export const listWebhookSources = WebhookSourceService.method.listWebhookSources;

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.UpdateWebhookSource
 */
export const updateWebhookSource = WebhookSourceService.method.updateWebhookSource;

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.DeleteWebhookSource
 */
export const deleteWebhookSource = WebhookSourceService.method.deleteWebhookSource;

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.RegenerateHmacKey
 */
export const regenerateHmacKey = WebhookSourceService.method.regenerateHmacKey;

/**
 * @generated from rpc gx.webhook.api.WebhookSourceService.RegenerateWebhookIdentifier
 */
export const regenerateWebhookIdentifier = WebhookSourceService.method.regenerateWebhookIdentifier;
